import { render, staticRenderFns } from "./SelectInventoryTypeBtn.vue?vue&type=template&id=2925bdb6&"
import script from "./SelectInventoryTypeBtn.vue?vue&type=script&lang=js&"
export * from "./SelectInventoryTypeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports